import { apiGet, apiPost } from '../utils/api';

/**
 * Récupère le classement (ex. top 3 "first") pour l'utilisateur connecté
 * @param {string} [type='first'] - Type de classement
 * @param {number} [limit=3] - Nombre max d'entrées (pour overlay podium: 3)
 * @returns {Promise<{ success: boolean, data: Array<{ rank, user_login, user_display_name, value }>, config?: Object }>}
 */
export async function getLeaderboard(type = 'first', limit = 3) {
  const params = new URLSearchParams();
  params.set('type', type);
  params.set('limit', String(Math.min(50, Math.max(1, limit))));
  const response = await apiGet(`twitch/leaderboard?${params.toString()}`);
  return response;
}

/**
 * Réinitialise le classement "first" pour la chaîne propriétaire.
 * @returns {Promise<{ success: boolean, message: string, data: { channel, deleted } }>}
 */
export async function resetLeaderboard() {
  const response = await apiPost('twitch/leaderboard/reset', {});
  return response;
}

/**
 * Ajoute ou retire des points à un utilisateur du classement First.
 * @param {string} userLogin - Login Twitch de l'utilisateur
 * @param {number} delta - Points à ajouter (positif) ou retirer (négatif)
 * @param {string} [displayName] - Nom d'affichage (optionnel)
 * @returns {Promise<{ success: boolean, message: string, data: Object }>}
 */
export async function adjustFirstPoints(userLogin, delta, displayName) {
  const body = { userLogin: userLogin.trim(), delta: Number(delta) };
  if (typeof displayName === 'string' && displayName.trim()) {
    body.displayName = displayName.trim();
  }
  const response = await apiPost('twitch/leaderboard/adjust', body);
  return response;
}
